





















import Vue, { PropType } from 'vue';
import { IQuote } from '@/models';

export default Vue.extend({
  name: 'QuoteExpiredLabel',

  props: {
    quote: { type: Object as PropType<IQuote> }
  }
});
